<template>
    <div class="entity-item">
        <span class="item-content">
            <span class="item-label" v-if="pureLabel" :title="getSelectedItemLabelText()" @click.stop>{{ getSelectedItemLabelText() }}</span>
            <simple-dropdown v-else
              :alignment="1"
              :dropdown-arrow="true"
              :mouse-enter-to-show="true"
              :click-dropdown-menu-to-hide="false"
              :animated="true"
              class="simple-dropdown"
              @dropdownMenuShown="onDropdownMenuShown"
            >
            <template v-slot:triggerButtonContent>
                <span class="item-label">{{ getSelectedItemLabelText() }}</span>
            </template>
            <template v-slot:dropdownMenu>
                <dynamic-display :load-data-api="getLoadEntityApi()" @loadEnd="onLoadEnd" :load-data-on-created="true"
                                 ref="dynamicDisplay" class="dynamic-display">
                    <template v-slot:showResultsContainer>
                        <div class="entity-item-detail-description">
                            <div class="property">
                                <span class="label">ID</span>:
                              <span class="value"><copyable-text
                                    :text="entityId"></copyable-text></span>
                              <a v-if="reviewLinkToAdminHK" class="ml-2"
                                 title="Review in AdminHK"
                                 target="_blank" :href="reviewLinkToAdminHK"><i class="gf gf-linkout"></i></a>
                            </div>
                            <div v-if="itemDetail" v-html="getSuggestionItemHTML(itemDetail, false)"></div>
                            <div v-else>
                                <div class="text-gray">Cannot find the entity, which may have been removed from the
                                    library.
                                </div>
                            </div>
                        </div>
                    </template>
                </dynamic-display>
            </template>
        </simple-dropdown>

        <i v-if="removable" class="remove-button gf gf-close" @click="onRemoveButtonClicked(item)"></i>
        <i class="gf gf-pin locate-button" v-if="itemDetail && showLocateButton"
           @click="tryToLocate"></i>
                </span>
    </div>
</template>

<script>
import SimpleDropdown from "@/components/SimpleDropdown";
import {itemValueProperty} from "@/config";
import {getEntity} from "@/apis";
import DynamicDisplay from "@/components/DynamicDisplay";
import CopyableText from "@/components/CopyableText";
import {getDataPointInSuggestionItem, getReviewCompanyLinkToAdminHK, getReviewPersonLinkToAdminHK} from "@/utils";

const getNamesOfEntity = (item) => {
  let nameEn, nameCh;
  if (item.objectType === 'person') {
    nameEn = getDataPointInSuggestionItem(item, 'Gekko_fullname');
    nameCh = getDataPointInSuggestionItem(item, 'Gekko_ch');
  } else if (item.objectType === 'company') {
    nameEn = getDataPointInSuggestionItem(item, 'Gekko_name_en');
    nameCh = getDataPointInSuggestionItem(item, 'Gekko_name_ch');
  }
  return {
    nameEn,
    nameCh,
  }
};

export default {
  name: "EntityItem",
  components: {CopyableText, DynamicDisplay, SimpleDropdown},
  methods: {
    tryToLocate() {
      if (!this.itemDetail) {
        return;
      }
      this.$emit('locateEntityNames', {detail: getNamesOfEntity(this.itemDetail)});
    },
    onRemoveButtonClicked() {
      this.$emit('clickRemoveButton', this.item);
    },
    getSelectedItemLabelText() {
      let nameEn, nameCh;
      const {itemDetail} = this;
      if (itemDetail) {
        nameEn = itemDetail.nameEn;
        nameCh = itemDetail.nameCh;
            }
            return nameEn ? nameEn : nameCh ? nameCh : this.entityId;
        },
        getLoadEntityApi() {
            return getEntity.bind(null, this.entityId);
        },
        onLoadEnd(showingResults, result) {
            if (result) {
                result = this.transformSuggestionsData([result]);
                this.itemDetail = result[0];
            } else {
                this.itemDetail = null;
            }
        },
        onDropdownMenuShown() {
            if (!this.itemDetail) {
                this.$refs.dynamicDisplay.loadData();
            }
        },
    },
    props: {
        item: Object,
        getSuggestionItemHTML: Function,
        transformSuggestionsData: Function,
        removable: {
            default: true,
        },
        showLocateButton: {
            default: false,
        },
        pureLabel: {
          default: false,
        }
    },
    data() {
        return {
            itemDetail: null,
        }
    },
    computed: {
        entityId() {
            return this.item[itemValueProperty];
        },
        reviewLinkToAdminHK() {
          let {entityId} = this;
          if (!entityId) {
            return null;
          }
          entityId = String(entityId);
          if (entityId.startsWith('10')) {
            return getReviewPersonLinkToAdminHK(this.entityId);
          }
          if (entityId.startsWith('11')) {
            return getReviewCompanyLinkToAdminHK(this.entityId);
          }
          return null;
        }
    }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";

.entity-item {
  margin: 4px 2px;
  max-width: calc(100% - 4px);

  .item-content {
    display: flex;
    align-items: center;
    padding: 0.1rem 0.3rem 0.1rem 0.5rem;
    background-color: #f0f0f0;
    border-radius: 999px;
    line-height: 1.2;
    max-width: 100%;
    border: 1px solid lightgray;

    .remove-button, .locate-button {
      font-size: 0.86em;
    }

    .locate-button {
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      padding-left: 0.2rem;
    }
  }

  .simple-dropdown {
    overflow: hidden;
  }

  .simple-dropdown.active, .simple-dropdown:hover {
    .item-label {

    }
  }
}

.remove-button, .locate-button {
    cursor: pointer;
    margin-left: 0.25rem;
}

.item-label {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  font-size: 0.9em;
  font-weight: 500;
}
</style>
<style lang="scss">
@import "../assets/variables";

.entity-item-detail-description {
    padding: 0.5rem 1rem;
    line-height: 1.25;
    max-width: 250px;

    .property {
        margin-bottom: 0.42rem;
        color: gray;
        display: flex;
        align-items: center;
    }

    .line {
        padding: 0.25rem 0;

        &:not(:last-child) {
            border-bottom: 1px solid #e0e0e0;
        }
    }
}
</style>
<style lang="scss" scoped>
.dynamic-display {
  width: 250px;
}
</style>
<style lang="scss">
.entity-item {
  .simple-dropdown {
    .trigger {
      max-width: 100%;
      display: inline-flex;
    }
  }
}
</style>
